import UploadContainer from "Container/Upload"
import UploadPresentation from 'Presentation/Upload'

const UploadScene = () => {
  return (
    <UploadContainer>
      <UploadPresentation />
    </UploadContainer>
  )
}

export default UploadScene